import React from 'react';

export default function Batch(props: { price: PriceTypes.Root; i18n: DetailTypes.i18n }) {
  const { price, i18n } = props;
  if (price.batchNum === 1) return null;

  return (
    <div className="batch-layout">
      1 {i18n['marketAction.lot']} = {price.batchNum}{' '}
      {price.batchNum > 1 ? price.unitEven : price.unit}
    </div>
  );
}
